const routes = [
  {
    path: "/matters/:uid",
    name: "matter",
    component: () => import(/* webpackChunkName: "ClientCard" */ "./views/Matter"),
    props: route => ({
      uid: route.params.uid,
      mobileView: route.query.MobileView === '1',
      paneView: route.query.PaneView === '1' || route.query.paneView === 'true',
      tab: route.query.tab,
      openOrigin: route.query.openOrigin
    })
  }
];

export default routes;
